module.exports = __webpack_public_path__ + "static/media/sample-evoucher-mobile.6bd6d92e.png";